/**
 * schemaPrompt.js — derive a compact extraction field_spec from a Form
 * Registry schema (src/forms/<Module>/schema.js).
 *
 * The spec mirrors { sections: [{id, title, repeatable, fields: [{id, label,
 * required, type, options}]}] } but is trimmed to what the Space needs.
 * All field types are sent; the Space includes every field in the prompt and
 * the client-side mapper coerces types afterwards (fieldMapper.js).
 */

export function buildFieldSpec(schema, opts = {}) {
  const { maxRepeatableItems = 3 } = opts;
  if (!schema || !Array.isArray(schema.sections)) {
    throw new Error('schema must define a sections array');
  }
  return {
    sections: schema.sections.map((section) => ({
      id: section.id,
      repeatable: Boolean(section.repeatable),
      fields: (section.fields || [])
        .filter((f) => f && f.id)
        .map((f) => ({
          id: f.id,
          label: f.label || f.id,
          required: Boolean(f.required),
          type: f.type || 'text',
          options: Array.isArray(f.options) ? f.options : undefined,
        })),
    })),
    maxRepeatableItems,
  };
}
